import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { setAuthToken, clearAuthToken } from '../services/api';

/**
 * Custom hook to handle Auth0 token management
 * Sets token in API client when user authenticates
 */
export const useApiAuth = () => {
  const { isAuthenticated, getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    if (!isAuthenticated) {
      clearAuthToken();
      return;
    }

    let isActive = true;
    const refreshIntervalMs = 4 * 60 * 1000;

    const refreshToken = async () => {
      try {
        const token = await getAccessTokenSilently({
          audience: process.env.REACT_APP_AUTH0_AUDIENCE,
          scope: 'openid profile email'
        });

        if (isActive) {
          setAuthToken(token);
        }
      } catch (err) {
        if (!isActive) return;
        clearAuthToken();
        console.error('Failed to obtain access token silently:', err);
      }
    };

    refreshToken();
    const intervalId = setInterval(refreshToken, refreshIntervalMs);

    return () => {
      isActive = false;
      clearInterval(intervalId);
    };
  }, [isAuthenticated, getAccessTokenSilently]);
};

export default useApiAuth;
